import { render } from "./OrderPostPaymentActions.vue?vue&type=template&id=54738161&ts=true"
import script from "./OrderPostPaymentActions.vue?vue&type=script&lang=ts"
export * from "./OrderPostPaymentActions.vue?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__